import { render, staticRenderFns } from "./FaqStructuredData.vue?vue&type=template&id=4abff5ff"
import script from "./FaqStructuredData.vue?vue&type=script&lang=js"
export * from "./FaqStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports